<template>
  <v-app>
    <v-main>
      <router-view />
      <Notify />
      <Loader />
    </v-main>
  </v-app>
</template>

<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import Notify from "@/components/notify/Notify";
import Loader from "@/components/Loader/Loader.vue";

const store = useStore();

function SessionCheck() {
  setInterval(() => {
    store.commit("setUserGroupId", localStorage.getItem("groupId"));
  }, 1000);
}

onMounted(() => {
  SessionCheck(); // функция для выхода по завершению сессии1
  // Cold F5 без resume_token: rehydrate → poll → password/waiting/start (RES-01)
  store.dispatch("coldHybridResumeIfNeeded");
});
</script>
